import AnalyticsClient from '@nearst/analytics-client';

export const analytics = new AnalyticsClient({ domain: 'unify' });
